export default "__VITE_ASSET__c427e896__"